(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.timer = null;
      this.paused = false;
      this.onResize = this.onResize.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
    }

    handleClick(e) {
      e.preventDefault();
      this.remove();
    }

    connectedCallback() {
      const closeBtn = this.querySelector('.announcement-bar__close');
      if (closeBtn) closeBtn.addEventListener('click', this.handleClick.bind(this));

      this.track = this.querySelector('[data-ab-track]');
      if (!this.track || this.dataset.carousel !== 'true') return;

      this.rows = Array.from(this.track.querySelectorAll('.announcement-bar__row'));
      this.prevBtn = this.querySelector('[data-ab-prev]');
      this.nextBtn = this.querySelector('[data-ab-next]');
      this.delay = parseInt(this.dataset.autoplay, 10) || 0;

      this.track.classList.add('is-ready');

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

      // Pause on hover (mouse only, so taps on mobile don't freeze it) and on keyboard focus
      this.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') this.pause();
      });
      this.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') this.resume();
      });
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.resume();
      });

      // Swipe on mobile
      this.track.addEventListener('touchstart', (e) => {
        const t = e.touches[0];
        this.touchX = t.clientX;
        this.touchY = t.clientY;
      }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        if (this.touchX == null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - this.touchX;
        const dy = t.clientY - this.touchY;
        this.touchX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(dx < 0 ? 1 : -1);
      }, { passive: true });

      // Theme editor: jump to the block being edited
      this.addEventListener('shopify:block:select', (e) => {
        const row = e.target.closest('.announcement-bar__row');
        const i = this.visibleRows().indexOf(row);
        if (i > -1) this.show(i);
        this.pause();
      });
      this.addEventListener('shopify:block:deselect', () => this.resume());

      window.addEventListener('resize', this.onResize);
      document.addEventListener('visibilitychange', this.onVisibility);

      this.refresh();
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    // Rows hidden by the mobile/tablet/desktop visibility toggles are skipped
    visibleRows() {
      return this.rows.filter((r) => getComputedStyle(r).display !== 'none');
    }

    refresh() {
      const visible = this.visibleRows();
      const current = this.rows.find((r) => r.classList.contains('is-active'));
      const i = visible.indexOf(current);
      this.show(i > -1 ? i : 0, visible);

      const single = visible.length < 2;
      if (this.prevBtn) this.prevBtn.hidden = single;
      if (this.nextBtn) this.nextBtn.hidden = single;

      this.restart();
    }

    show(i, visible = this.visibleRows()) {
      if (!visible.length) return;
      this.index = (i + visible.length) % visible.length;
      const active = visible[this.index];
      this.rows.forEach((r) => r.classList.toggle('is-active', r === active));
    }

    go(step) {
      this.show(this.index + step);
      this.restart();
    }

    restart() {
      this.stop();
      if (!this.delay || this.paused || document.hidden) return;
      if (this.visibleRows().length < 2) return;
      this.timer = setInterval(() => this.show(this.index + 1), this.delay);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    pause() {
      this.paused = true;
      this.stop();
    }

    resume() {
      this.paused = false;
      this.restart();
    }

    onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.refresh(), 150);
    }

    onVisibility() {
      if (document.hidden) this.stop();
      else this.restart();
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
      // Matches the markup, which ships without the hidden class.
      // connectedCallback picks the real starting state. Scrolling down reveals
      // the bar, scrolling up hides it. Flip `show` in handleScroll() to invert.
      this.isHidden = false;
      this.barHeight = 0;
      this.lastScrollY = Math.max(window.scrollY, 0);
      this.scrollThreshold = 5;
      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Hidden from JS rather than from the markup: if the theme bundle never
      // runs, the bar stays visible and the body keeps its padding fallback,
      // i.e. the behaviour before this feature existed. The transition is
      // suppressed for this first hide so the bar does not animate away on load.
      this.classList.add('mobile-sticky-bar--no-transition');
      this.measure();
      this.toggle(this.isNearBottom());
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('mobile-sticky-bar--no-transition');
        });
      });
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      document.documentElement.style.removeProperty('--f-mobile-navbar-offset');
    }

    measure() {
      // offsetHeight is unaffected by the hide transform, and is 0 while the
      // bar is display:none (>= 768px), which zeroes the offset on desktop.
      this.barHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.barHeight + 'px');
      this.syncOffset();
    }

    /* Publishes the height the bar currently occupies so the sticky ATC bar can
       stack on top of it. The body padding-bottom no longer reads this - it is
       reserved at full height regardless of the hide/show state. */
    syncOffset() {
      document.documentElement.style.setProperty(
        '--f-mobile-navbar-offset',
        (this.isHidden ? 0 : this.barHeight) + 'px'
      );
    }

    handleResize() {
      this.measure();
      if (this.isHidden && this.isNearBottom()) this.toggle(true);
    }

    /* The body keeps a constant padding-bottom the height of this bar. That
       strip is only covered while the bar is on screen, so it must stay below
       the fold before the bar is allowed to hide - otherwise scrolling up from
       the end of the page exposes it as an empty gap. */
    isNearBottom() {
      const distanceFromBottom = Math.max(
        document.documentElement.scrollHeight - window.scrollY - window.innerHeight,
        0
      );
      return distanceFromBottom < this.barHeight;
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        const scrollY = Math.max(window.scrollY, 0);
        const delta = scrollY - this.lastScrollY;
        if (Math.abs(delta) < this.scrollThreshold) return;
        this.lastScrollY = scrollY;
        const show = delta > 0;
        if (!show && this.isNearBottom()) return;
        this.toggle(show);
      });
    }

    toggle(show) {
      const shouldHide = !show;
      if (this.isHidden === shouldHide) return;
      this.isHidden = shouldHide;
      this.classList.toggle('mobile-sticky-bar--hidden', shouldHide);
      this.syncOffset();
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
